// Rough phonetic transliteration of Latin-script (mostly French) product names into
// Arabic script — letter-by-letter, no dictionary. Meant as a reading aid on the
// products listing when the UI is in Arabic, not a real translation of meaning.
// Multi-letter French phonemes are matched first (longest match wins) so common
// sounds (ch, ou, an, tion...) read naturally instead of as a pile of single letters.

// Longest-first — order matters for greedy matching.
const MULTI_LETTER_RULES = [
    ['TION', 'سيون'],
    ['EAU', 'و'],
    ['ILL', 'ي'],
    ['AIN', 'ان'],
    ['EIN', 'ان'],
    ['CH', 'ش'],
    ['PH', 'ف'],
    ['GN', 'ني'],
    ['QU', 'ك'],
    ['OU', 'و'],
    ['AU', 'و'],
    ['AI', 'ي'],
    ['EI', 'ي'],
    ['EU', 'و'],
    ['AN', 'ان'],
    ['AM', 'ام'],
    ['EN', 'ان'],
    ['EM', 'ام'],
    ['ON', 'ون'],
    ['OM', 'وم'],
    ['IN', 'ين'],
    ['IM', 'يم'],
    ['OI', 'وا'],
];

const SINGLE_LETTER_MAP = {
    A: 'ا', B: 'ب', C: 'ك', D: 'د', E: 'ي', F: 'ف', G: 'غ', H: 'ه', I: 'ي',
    J: 'ج', K: 'ك', L: 'ل', M: 'م', N: 'ن', O: 'و', P: 'ب', Q: 'ق', R: 'ر',
    S: 'س', T: 'ت', U: 'و', V: 'ڤ', W: 'و', X: 'كس', Y: 'ي', Z: 'ز',
    É: 'ي', È: 'ي', Ê: 'ي', Ë: 'ي', À: 'ا', Â: 'ا', Ï: 'ي', Î: 'ي',
    Ô: 'و', Ù: 'و', Û: 'و', Ü: 'و', Ç: 'س',
};

// C/G sound soft before E or I (façade/générique-style French pronunciation).
const contextualLetter = (letter, next) => {
    const isSoftVowel = next === 'E' || next === 'I' || next === 'É' || next === 'È';
    if (letter === 'C' && isSoftVowel) return 'س';
    if (letter === 'G' && isSoftVowel) return 'ج';
    return SINGLE_LETTER_MAP[letter];
};

export const transliterateToArabic = (text) => {
    if (!text) return '';
    const upper = text.toUpperCase();
    let result = '';
    let i = 0;

    while (i < upper.length) {
        const remaining = upper.slice(i);
        const rule = MULTI_LETTER_RULES.find(([latin]) => remaining.startsWith(latin));
        if (rule) {
            result += rule[1];
            i += rule[0].length;
            continue;
        }

        const char = upper[i];
        const arabic = contextualLetter(char, upper[i + 1]);
        result += arabic ?? text[i];
        i += 1;
    }

    return result;
};

export default transliterateToArabic;
